
<div class="tkeuser-form_Custom">
  <form [formGroup]="tkeUserForm" class="internalMax" (ngSubmit)="onSubmit()">
    @if (defaults.componentTool === componentToolEnum.Rulebook) {
      <div class="row">
        <div class="col-sm-12 form-group">
          <div style="border:1px solid; padding:10px">
            <p>
              User will get a basic Power BI license allowing to consume Power BI reports
              <br>
                published on a Power BI Premium Workspace.
              </p>
            </div>
          </div>
        </div>
      }


      <div class="row">
        <div class="col-sm-6 form-group">

          <mat-form-field appearance="outline">
            <mat-label> First Name </mat-label>
            <input matInput formControlName="firstName" required>
          </mat-form-field>
          @if (
            tkeUserForm.get('firstName')?.invalid &&
            (tkeUserForm.get('firstName')?.dirty ||
            tkeUserForm.get('firstName')?.touched)) {
            <p class="p-max-height">
              @if (tkeUserForm.get('firstName')?.hasError('required')) {
                <mat-error>This field is required</mat-error>
              }
              @if (tkeUserForm.get('firstName')?.hasError('maxlength')) {
                <mat-error>Max {{ limits.GivenName }} characters</mat-error>
              }
            </p>
          }
          @if (!(
            tkeUserForm.get('firstName')?.invalid &&
            (tkeUserForm.get('firstName')?.dirty ||
            tkeUserForm.get('firstName')?.touched))) {
            <p><br> </p>
          }

        </div>
        <div class="col-sm-6 form-group">

          <mat-form-field appearance="outline">
            <mat-label> Last Name </mat-label>
            <input matInput formControlName="lastName" required>
          </mat-form-field>
          @if (
            tkeUserForm.get('lastName')?.invalid &&
            (tkeUserForm.get('lastName')?.dirty ||
            tkeUserForm.get('lastName')?.touched)) {
            <p class="p-max-height">
              @if (tkeUserForm.get('lastName')?.hasError('required')) {
                <mat-error>This field is required</mat-error>
              }
              @if (tkeUserForm.get('lastName')?.hasError('maxlength')) {
                <mat-error>Max {{ limits.Surname }} characters</mat-error>
              }
            </p>
          }
          @if (!(
            tkeUserForm.get('lastName')?.invalid &&
            (tkeUserForm.get('lastName')?.dirty ||
            tkeUserForm.get('lastName')?.touched))) {
            <p><br> </p>
          }
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 form-group">

          <!--Displayname Region-->
          <mat-form-field appearance="outline">
            <mat-label> Display Name </mat-label>
            <input matInput formControlName="displayName" required>
          </mat-form-field>
          @if (
            tkeUserForm.get('displayName')?.invalid &&
            (tkeUserForm.get('displayName')?.dirty ||
            tkeUserForm.get('displayName')?.touched)) {
            <p class="p-max-height">
              @if (tkeUserForm.get('displayName')?.hasError('required')) {
                <mat-error>This field is required</mat-error>
              }
              @if (tkeUserForm.get('displayName')?.hasError('maxlength')) {
                <mat-error>Max {{ limits.DisplayName }} characters</mat-error>
              }
            </p>
          }
          @if (!(
            tkeUserForm.get('displayName')?.invalid &&
            (tkeUserForm.get('displayName')?.dirty ||
            tkeUserForm.get('displayName')?.touched))) {
            <p><br> </p>
          }
        </div>
      </div>

      <div class="row">
        @if (defaults.componentTool !== componentToolEnum.Mersy)
        {
          <div class="col-sm-4 form-group">
            <br />
            <mat-label> <span>Tenant</span><span class="orange-asterisk"> *</span></mat-label>
          </div>
          <div class="col-sm-8 form-group">

            <!--Primary Tenant Drop Down-->
            <ng-select [items]="tenants"
              [searchable]="true"
              [clearable]="false"
              class="tenantStyling"
              bindLabel="text"
              bindValue="value"
              formControlName="tenant"
              appendTo="body"
              required>
            </ng-select>
            <br>
          </div>
        }
        @else {
          <div class="col-sm-4 form-group">
            <br />
            <mat-label> <span>Location</span><span class="orange-asterisk"> *</span></mat-label>
          </div>
          <div class="col-sm-8 form-group">

            <!--Primary Tenant Drop Down-->
            <ng-select [items]="usageLocations"
              [searchable]="true"
              [clearable]="false"
              class="tenantStyling"
              bindLabel="text"
              bindValue="value"
              formControlName="usageLocation"
              appendTo="body"
              required>
            </ng-select>
            <br>
          </div>
        }
      </div>

        <!--<div class="row">
        <div class="col-sm-4 form-group">
          <br />
          <mat-label>Secondary Tenant</mat-label>
        </div>
        <div class="col-sm-8 form-group">-->

          <!--Secondary Tenant Drop Down-->
          <!--<ng-select (change)="onSecTenChange()"
          [matTooltip]="selectedSecTenString"
          [matTooltipPosition]="'above'"
          [items]="secondaryTenants"
          groupBy="selectedAllGroup"
          [selectableGroup]="true"
          [selectableGroupAsModel]="false"
          [searchable]="true"
          [clearable]="true"
          [closeOnSelect]="false"
          [multiple]="true"
          bindLabel="text"
          bindValue="value"
          formControlName="secondaryTenant">

          <ng-template ng-optgroup-tmp>
            Select All
          </ng-template>

          <ng-template ng-option-tmp
            let-item="item">
            {{ item.text }}
          </ng-template>

          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div class="items-selected" *ngIf="this.tkeUserForm.controls['secondaryTenant'].value.length <= 2">
              <div class="ng-value" *ngFor="let item of this.tkeUserForm.controls['secondaryTenant'].value ">
                <span class="ng-value-label">{{item}}</span>

              </div>
            </div>

            <div class="ng-value" *ngIf="items.length > 2">
              <span class="ng-value-label">{{items.length}} Selected...</span>
            </div>

          </ng-template>

        </ng-select>
        <br>

        </div>
      </div>-->

      <div class="row">
        <div class="col-sm-4 form-group">
          <br />
          <span>Email</span><span class="orange-asterisk"> *</span>
        </div>
        <div class="col-sm-8 form-group">

          <!--Email Region-->
          <div>
            <mat-form-field appearance="outline">
              <mat-label>Email</mat-label>
              <input matInput placeholder="pat@example.com" formControlName="email" required (keyup)="changeEmail($event)">
              <mat-spinner #spinner matSuffix [diameter]="18" style="float: right; margin-left: 8px; visibility:hidden"></mat-spinner>
            </mat-form-field>

            @if (
              tkeUserForm.get('email')?.invalid &&
              (tkeUserForm.get('email')?.dirty ||
              tkeUserForm.get('email')?.touched)) {
              <p class="p-max-height">
                @if (tkeUserForm.get('email')?.hasError('required')) {
                  <mat-error>This field is required</mat-error>
                }
                @if (tkeUserForm.get('email')?.hasError('pattern') || tkeUserForm.get('email')?.hasError('email')) {
                  <mat-error>
                    Enter valid email
                  </mat-error>
                }
                @if (tkeUserForm.get('email')?.hasError('maxlength')) {
                  <mat-error>Max {{ limits.Mail }} characters</mat-error>
                }
              </p>
            }
            <p igIf="emailError">
              <mat-error>{{emailError}}</mat-error>
            </p>
            @if (!(
              tkeUserForm.get('email')?.invalid &&
              (tkeUserForm.get('email')?.dirty ||
              tkeUserForm.get('email')?.touched)) && !emailError) {
              <p><br> </p>
            }
          </div>

        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 form-group">
          <br />
          <span>Company Name</span><span class="orange-asterisk"> *</span>
        </div>
        <div class="col-sm-8 form-group">

          <!--Company Name Region-->
          <div>
            <mat-form-field appearance="outline">
              <mat-label>Company Name</mat-label>
              <input matInput formControlName="companyName" required>
            </mat-form-field>

            @if (
              tkeUserForm.get('companyName')?.invalid &&
              (tkeUserForm.get('companyName')?.dirty ||
              tkeUserForm.get('companyName')?.touched)) {
              <p class="p-max-height">
                @if (tkeUserForm.get('companyName')?.hasError('required')) {
                  <mat-error>This field is required</mat-error>
                }
                @if (tkeUserForm.get('companyName')?.hasError('maxlength')) {
                  <mat-error>Max {{ limits.CompanyName }} characters</mat-error>
                }
              </p>
            }
            @if (!(
              tkeUserForm.get('companyName')?.invalid &&
              (tkeUserForm.get('companyName')?.dirty ||
              tkeUserForm.get('companyName')?.touched))) {
              <p><br> </p>
            }
          </div>

        </div>
      </div>




      <div class="row">
        <div class="panel-body">
          <button (click)="backButtonHandler($event)" mat-raised-button class="btn button-fix button-color-fix-red">
            <mat-icon class=" icon-color-fix ">arrow_back_ios</mat-icon>
            Back
          </button>
          <button mat-raised-button type="submit" class="btn button-fix button-color-fix-orange pull-right" [disabled]="!tkeUserForm.valid || emailError || waiting4Mail">
            Create
            <mat-icon class=" icon-color-fix ">person</mat-icon>
          </button>
        </div>
      </div>

    </form>
  </div>
